import FlightLandIcon from "@mui/icons-material/FlightLand";
import HomeIcon from "@mui/icons-material/Home";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import { reloadForNewVersion } from "../utils/lazyWithRetry";

type ErrorProps = {
  error?: unknown;
  componentStack?: string | null;
  resetError?: () => void;
  /**
   * "crash" (default): something broke, back to Home.
   * "new-version": a page's code is gone after a deploy (src/utils/lazyWithRetry.ts)
   * and the automatic reload already happened, so offer a Reload.
   */
  variant?: "crash" | "new-version";
};

const Error = ({ error, componentStack, resetError, variant = "crash" }: ErrorProps) => {
  const newVersion = variant === "new-version";
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      spacing={2}
      textAlign="center"
      data-testid={newVersion ? "new-version" : "500"}
      sx={{ mt: 8 }}
    >
      <FlightLandIcon sx={{ fontSize: 200 }} color="primary" />
      <Typography variant="h1" sx={{ textAlign: "center" }} color="secondary">
        {newVersion ? "A new version is available" : "Oops! Something's gone wrong."}
      </Typography>
      {newVersion && <Typography>Reload to continue with the latest version of Aeronet.</Typography>}
      {process.env.NODE_ENV === "development" && (
        <>
          <div>{String(error)}</div>
          <div>{componentStack}</div>
        </>
      )}
      {newVersion ? (
        <Button variant="outlined" sx={{ mt: 4 }} startIcon={<RefreshIcon />} onClick={reloadForNewVersion}>
          Reload
        </Button>
      ) : (
        <Button
          variant="outlined"
          sx={{ mt: 4 }}
          startIcon={<HomeIcon />}
          component={Link}
          to="/"
          onClick={() => {
            resetError?.();
          }}
        >
          Back to Home
        </Button>
      )}
    </Stack>
  );
};

export default Error;
